import { Indicator } from '../../../Common/Charts/Indicator';
import { useGeneralResultsChartsDataContext } from './hooks/useGeneralResultsChartsDataContext';

export const WeightIndex = () => {
    const { chartData } = useGeneralResultsChartsDataContext();

    return (
        <Indicator
            title={'Índice de Peso (menor que 2.5 kg)'}
            indicatorValue={chartData?.indicators?.weightIndex}
            className='aligned-container'
        />
    );
};
